import { EmailTypes} from "../types/EmailTypes";
import { PricesForm } from '../classes/PricesForm';
import { GACategoryTypes } from "../types/GACategoryTypes";
import { GAEventTypes } from "../types/GAEventTypes";
import { GA } from "../classes/GA";

export class PricesPage {

  _pricesPageWrapperEl;
  _firstStepErrorEl;
  _appsElements;
  _confirmSelectedAppsButtonEl;
  _pricesPageWrapperAppsSelectionSectionEl;
  _confirmationFormEl;
  _navEl;
  _appsWrapperEl;
  _formConfirmationWrapperEl;
  _headerEl;
  _emailInputEl;
  _textareaEl;
  _appsElementsValueInputs;
  _selectedApps = {};

  init() {
    this._pricesPageWrapperEl = document.querySelector('.prices-page-wrapper');

    if (this._pricesPageWrapperEl) {
      this.afterPageRender();
    }
  }

  afterPageRender() {
    this._firstStepErrorEl = this._pricesPageWrapperEl.querySelector('.error-text');
    this._headerEl = this._pricesPageWrapperEl.querySelector('.header');
    this._appsWrapperEl = this._pricesPageWrapperEl.querySelector('.apps-wrapper');
    this._appsElements = Array.from(this._pricesPageWrapperEl.querySelectorAll('.apps-list__app'));
    this._confirmSelectedAppsButtonEl = this._pricesPageWrapperEl.querySelector('.confirm-selected-apps-button');
    this._pricesPageWrapperAppsSelectionSectionEl = this._pricesPageWrapperEl.querySelector('.prices-page-wrapper__apps-selection-section');
    this._confirmationFormEl = this._pricesPageWrapperEl.querySelector('.prices-page-wrapper__apps-selection-section__inner__confirmation-form');
    this._navEl = document.querySelector('.nav');
    this._formConfirmationWrapperEl = this._pricesPageWrapperEl.querySelector('.form-confirmation-wrapper');
    this._emailInputEl = this._pricesPageWrapperEl.querySelector('input[type="email"]');
    this._textareaEl = this._pricesPageWrapperEl.querySelector('textarea');
    this._appsElementsValueInputs = this._pricesPageWrapperEl.querySelectorAll('.apps-list__app .value-input');

    this.appsElementsActions();
    this.confirmSelectedApps();
  }

  appsElementsActions() {
    this._appsElements.forEach(x => {
      const minusBtn = x.querySelector('.counter__minus-button');
      const plusBtn = x.querySelector('.counter__plus-button');
      const valueInp = x.querySelector('.value-input');
      const productName = x.querySelector('.app-name').innerText;

      minusBtn.addEventListener('click', () => {
        const currentVal = +valueInp.value;

        if (currentVal > 0) {
          valueInp.value = currentVal - 1;
          this._selectedApps[productName] = valueInp.value;

          if(!+this._selectedApps[productName]) {
            delete this._selectedApps[productName];
          }
        }
      });

      plusBtn.addEventListener('click', () => {
        if (!this._firstStepErrorEl.classList.contains('d-none')) {
          this._firstStepErrorEl.classList.add('d-none');
          this._appsElementsValueInputs.forEach(x => x.classList.remove('text-color-error'));
        }

        valueInp.value = (+valueInp.value) + 1;
        this._selectedApps[productName] = valueInp.value;
      });
    });
  }

  confirmSelectedApps() {
    this._confirmSelectedAppsButtonEl.addEventListener('click', () => {
      if (this.areAnyAppsSelected()) {
        this._confirmSelectedAppsButtonEl.classList.add('d-none');
        this._confirmationFormEl.classList.remove('d-none');

        this.confirmFormActions();
      } else {
        this.showAppsSelectionError();
      }
    });
  }

  areAnyAppsSelected() {
    return this._appsElements.some(x => +(x.querySelector('.value-input').value) > 0);
  }

  confirmFormActions() {
    if (
      typeof ga === 'function' &&
      window['areCookiesPreferencesSet'] &&
      window['cookiesPreferences'].analyticsCookie
    ) {
      ga('send', 'event', GACategoryTypes.TrackingContactUs, GAEventTypes.PriceStart);
      dataLayer.push({ 'event': `cc_${GACategoryTypes.TrackingContactUs}_${GAEventTypes.PriceStart}` });
    }

    const pricesForm = new PricesForm(
      this._confirmationFormEl,
      this._appsWrapperEl,
      this._headerEl,
      this.showConfirmationEl.bind(this),
      EmailTypes.RequestProduct,
      this._selectedApps,
      GACategoryTypes.TrackingContactUs,
      GAEventTypes.PriceSent
    );

    pricesForm.init();
  }

  showConfirmationEl() {
    const textUnderHeading = this._formConfirmationWrapperEl.querySelector('.text-under-heading');
    textUnderHeading.textContent = textUnderHeading.textContent.replace(
      '[[customerEmailAddress]]',
      this._emailInputEl.value
    );

    this._formConfirmationWrapperEl.classList.remove('d-none');
    this._pricesPageWrapperEl.style.marginTop = '60px';

    window.scrollTo({
      top: 0
    });
  }

  showAppsSelectionError() {
    this._firstStepErrorEl.classList.remove('d-none');
    this._appsElementsValueInputs.forEach(x => x.classList.add('text-color-error'));

    window.scrollTo({
      top: this._pricesPageWrapperAppsSelectionSectionEl.offsetTop - this._navEl.offsetHeight,
      behavior: 'smooth'
    });
  }
}
